/* eslint-disable */
import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import { RouterWrapper } from 'routes';

import './assets/styles/sso.scss';

if (process.env.NODE_ENV === 'production') {
  require('./segment');
};

ReactDOM.render((
  <RouterWrapper>
    <App />
  </RouterWrapper>
), document.getElementById('root'));
